import React from 'react';
import { User } from 'lucide-react';

interface DisplayNameProps {
  displayName: string;
  setDisplayName: React.Dispatch<React.SetStateAction<string>>;
  isLoading: boolean;
}

export const DisplayName: React.FC<DisplayNameProps> = ({
  displayName,
  setDisplayName,
  isLoading,
}) => {
  return (
    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-6">
      <label htmlFor="displayName" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        <User className="w-4 h-4 inline mr-2" />
        Display Name
      </label>
      <input
        id="displayName"
        type="text"
        value={displayName}
        onChange={(e) => setDisplayName(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        placeholder="Enter your display name"
        disabled={isLoading}
      />
      <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
        This name will be displayed to other members in your teams.
      </p>
    </div>
  );
};